import { addArrayParams } from '../helpers';
import { BasePaginatedModel } from './BasePaginatedModel';

export interface GetTransactionsModel extends BasePaginatedModel {
  eventId?: string;
  organizationId?: string;
  searchTerm?: string;
  formEntryId?: string;
  couponCodeId?: string;
  paymentMethod?: string;
  type?: string;
  status?: 'paid' | 'refunded' | 'pending' | 'unpaid' | 'canceled' | null;
  from?: string | null;
  to?: string | null;
  subsetIds?: string[];
  excludedIds?: string[];
  sortDirection?: 'ascending' | 'descending';
  sortField?:
    | 'id'
    | 'paymentGatewayId'
    | 'creationDate'
    | 'paymentMethod'
    | 'nameOnCard'
    | 'last4Digits'
    | 'itemsCount'
    | 'couponCode'
    | 'forUserFullName'
    | 'paidByUserFullName'
    | 'status'
    | 'type'
    | 'subTotal'
    | 'gst'
    | 'hst'
    | 'qst'
    | 'vat'
    | 'pst'
    | 'total'
    | 'paymentGatewayFee'
    | 'fee'
    | 'feeGst'
    | 'feeHst'
    | 'feeQst'
    | 'profit'
    | 'billingInfoName';
}

export enum PaymentMethodFilter {
  Invoicing = 'invoicing',
  CreditCard = 'creditcard',
  PayPal = 'paypal',
  Void = 'void',
  ForwardPayment = 'forwardpayment',
}

export function toTransactionsSearchParams(model: GetTransactionsModel): URLSearchParams {
  const query = new URLSearchParams(model as any);
  // URLSearchParams do not handles array, ex: foo=bar1&foo=bar2
  addArrayParams(query, 'subsetIds', model.subsetIds);
  addArrayParams(query, 'excludedIds', model.subsetIds);
  return query;
}
